import { render, staticRenderFns } from "./AddDownloadConfig.vue?vue&type=template&id=24b6fa62"
import script from "./AddDownloadConfig.vue?vue&type=script&lang=js"
export * from "./AddDownloadConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports